import api from "../../api/axios";

const BASE = "/wf-1";

/** Lista W1 — aceita {ok,data} ou array cru, normalizando para [] */
export async function listarW1({ limit = 500, offset = 0 } = {}) {
  const { data } = await api.get(`${BASE}/listar`, { params: { limit, offset } });
  // Seu backend geralmente responde { ok, data }; mas aceito outras formas
  if (Array.isArray(data)) return data;
  if (data?.ok) return data.data || data.rows || [];
  // fallback mais tolerante
  return data?.data || data?.rows || [];
}

/**
 * Atualiza parcialmente um W1 (PATCH/PUT/POST), com fallbacks de rota:
 * - PUT   /wf-1/atualizar/:id
 * - PATCH /wf-1/atualizar/:id
 * - PUT   /wf-1/:id
 * - PATCH /wf-1/:id
 * - POST  /wf-1/atualizar { id, ...patch }
 */
export async function atualizarW1(id, patch = {}) {
  if (!id) throw new Error("id obrigatório");

  const tries = [
    { method: "put",   url: `${BASE}/atualizar/${id}`, body: patch },
    { method: "patch", url: `${BASE}/atualizar/${id}`, body: patch },
    { method: "put",   url: `${BASE}/${id}`,           body: patch },
    { method: "patch", url: `${BASE}/${id}`,           body: patch },
    { method: "post",  url: `${BASE}/atualizar`,       body: { id, ...patch } },
  ];

  let lastErr = null;

  for (const t of tries) {
    try {
      const { data } = await api.request({ method: t.method, url: t.url, data: t.body });
      // normaliza retorno
      if (data?.ok !== undefined) return data;
      return { ok: true, data };
    } catch (e) {
      const st = e?.response?.status;
      // se for erro “real” (não é rota inexistente), propaga
      if (st && ![404, 405].includes(st)) throw e;
      lastErr = e; // tenta próxima
    }
  }

  throw (lastErr || new Error("not_found"));
}

/** (Opcional) Buscar um único registro */
export async function obterW1(id) {
  const { data } = await api.get(`${BASE}/${id}`);
  if (data?.ok !== undefined) return data.data;
  return data?.data ?? data;
}
